import { render, staticRenderFns } from "./TelenologyDetail.vue?vue&type=template&id=81003c44&scoped=true"
import script from "./TelenologyDetail.vue?vue&type=script&lang=js"
export * from "./TelenologyDetail.vue?vue&type=script&lang=js"
import style0 from "./TelenologyDetail.vue?vue&type=style&index=0&id=81003c44&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81003c44",
  null
  
)

export default component.exports